import React from 'react'
import { IState } from 'store'
import { connect } from 'react-redux'
import { Paper, Button } from '@material-ui/core'
import { ControlSlider } from '../../shared/ui/ControlSlider'
import { inputs } from '../../../models/complex-model/inputs'
import { scenarios } from '../../../models/complex-model/scenarios'
import { useQueryHash } from '../../../base/hooks/useQueryHash'
import { simulationService } from '../../../services/SimulationService'
import { useOnMount } from '../../../base/hooks/useOnMount'
import { IStoredRun } from '../../../store/state'
import { ControlScenario } from './control/Scenario'
import styles from './Control.module.scss'
import { ControlInfo } from './control/Info'
import { number } from 'yup'

interface Props {
  values: TObjectAny
  storedRuns: IStoredRun[]
}

const ViewSimulationControl = ({ values, storedRuns }: Props) => {
  const [queryHash, setQueryHash] = useQueryHash()
  const [inc, setInc] = React.useState(0)

  useOnMount(() => {
    Object.keys(queryHash).forEach(k => {
      simulationService.updateValue(k, queryHash[k])
    })
  })

  React.useEffect(() => {
    setQueryHash({ ...queryHash, ...values })
    setInc(i => i + 1)
    // eslint-disable-next-line
  }, [values])

  const onChange = (inputVar: string, value: number) => {
    simulationService.updateValue(inputVar, value)
  }

  const onReset = () => {
    simulationService.reset()
  }

  return (
    <Paper className={`${styles.root}`}>
      <div className="tour-step-2">
        <div className={styles.title}>
          Control Panel
          {/* <ControlInfo /> */}
        </div>

        <div key={inc}>
          {inputs.map(i => (
            <ControlSlider
              key={i.var}
              label={i.label}
              min={i.min}
              max={i.max}
              step={i.step}
              value={queryHash[i.var] || values[i.var]}
              onChange={v => onChange(i.var, v)}
            />
          ))}
        </div>
      </div>
      <div className="tour-step-3">
        <div className={styles.buttons}>
          <Button
            className={styles.button}
            variant={'contained'}
            color={'primary'}
            onClick={() => simulationService.storeCurrentRun()}
          >
            Store scenario
          </Button>
          <Button
            className={styles.button}
            variant={'contained'}
            onClick={onReset}
          >
            Reset
          </Button>
        </div>
        <div className={styles.runs}>
          {storedRuns.map((storedRun, i) => (
            <ControlScenario key={storedRun.key} storedRun={storedRun} index={i} />
          ))}
        </div>
        <div className={styles.modelLinkContainer}>
          <a
            href="https://sheetless.io/@Synergia/infectious-disease/app?dash=true"
            target="_blank"
            className={styles.modelLink}
          >
            View original model
          </a>
        </div>
      </div>
    </Paper>
  )
}

const mapStateToProps = (state: IState, ownProps: any): Props => ({
  values: state.app.simulation.values,
  storedRuns: state.app.simulation.storedRuns,
})

const Connected = connect(mapStateToProps)(ViewSimulationControl)

export { Connected as ViewSimulationControl }
